export const jsonToCsv = (jsonData) => {
    if (!Array.isArray(jsonData) || jsonData.length === 0) {
        return "";
    }
    const escapeCsvValue = (value) => {
        if (value === null || value === undefined) {
            return '';
        }
        const stringValue = String(value);
        // If value contains comma, quote, or newline, wrap in quotes and escape quotes
        if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
            return `"${stringValue.replace(/"/g, '""')}"`;
        }
        return stringValue;
    };
    let csv = '';
    const headers = Object.keys(jsonData[0]);
    csv += headers.map(header => escapeCsvValue(header)).join(',') + '\n';
    jsonData.forEach(obj => {
        const values = headers.map(header => escapeCsvValue(obj[header]));
        csv += values.join(',') + '\n';
    });
    return csv;
};

export const downloadCsvFile = (data, filename) => {
    const csvData = new Blob([jsonToCsv(data)], { type: 'text/csv' });
    const csvURL = URL.createObjectURL(csvData);
    const link = document.createElement('a');
    link.href = csvURL;
    link.download = filename + ".csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};